import type { FC, SVGProps } from "react";

const ChevronRightIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		width="12"
		height="12"
		viewBox="0 0 12 12"
		fill="none"
		aria-hidden="true"
		{...props}
	>
		<path
			d="M4.5 2.5l3.5 3.5-3.5 3.5"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export { ChevronRightIcon };
